import { DeliveryState, Term } from 'types/api';

export interface DeliveryParam {
  size: number;
  filter: DeliveryFilterInput;
}

export interface DeliveryFilterInput {
  addressLike?: string;
  courierIds: string[];
  customerIds?: string[];
  emailLike?: string;
  hostId?: string;
  ids?: string[];
  nameLike?: string;
  orderIds?: string[];
  orderItemIds?: string[];
  phoneLike?: string;
  recipientEmailLike?: string;
  recipientNameLike?: string;
  recipientPhoneLike?: string;
  statusIn?: DeliveryState[];
  statusNotIn?: DeliveryState[];
  term?: Term;
  trackingNo?: string;
}

export interface TrackingInfoInput {
  courierId?: string | null;
  deliveryId: string;
  trackingNo?: string | null;
}

export const INITIAL_DELIVERY_PARAM: DeliveryParam = {
  size: 20,
  filter: {
    addressLike: null,
    courierIds: null,
    customerIds: null,
    orderIds: null,
    orderItemIds: null,
    ids: null,
    emailLike: null,
    hostId: null,
    nameLike: null,
    phoneLike: null,
    recipientEmailLike: null,
    recipientNameLike: null,
    recipientPhoneLike: null,
    statusIn: null,
    term: null,
    trackingNo: null,
  },
};
